import _regeneratorRuntime from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import { _ as r } from "../chunks/tslib.es6.js";
import { clone as o } from "../core/lang.js";
import { numericHash as t } from "../core/string.js";
import { property as e } from "../core/accessorSupport/decorators/property.js";
import "../core/accessorSupport/ensureType.js";
import { enumeration as s } from "../core/accessorSupport/decorators/enumeration.js";
import { reader as a } from "../core/accessorSupport/decorators/reader.js";
import { subclass as i } from "../core/accessorSupport/decorators/subclass.js";
import { writer as p } from "../core/accessorSupport/decorators/writer.js";
import { collectArcadeFieldNames as c } from "../layers/support/fieldUtils.js";
import n from "./Symbol.js";

var _m;

var l = _m = /*#__PURE__*/function (_n) {
  _inherits(m, _n);

  var _super = _createSuper(m);

  function m(r) {
    var _this;

    _classCallCheck(this, m);

    _this = _super.call(this, r), _this.data = null, _this.type = "cim";
    return _this;
  }

  _createClass(m, [{
    key: "readData",
    value: function readData(r, o) {
      return o;
    }
  }, {
    key: "writeData",
    value: function writeData(r, o) {
      if (r) for (var _t in r) {
        o[_t] = r[_t];
      }
    }
  }, {
    key: "collectRequiredFields",
    value: function () {
      var _collectRequiredFields = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(r, o) {
        var _t2, _e;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!("CIMSymbolReference" === this.data.type)) {
                  _context.next = 6;
                  break;
                }

                _t2 = this.data.primitiveOverrides;

                if (!_t2) {
                  _context.next = 6;
                  break;
                }

                _e = _t2.map(function (t) {
                  var e = t.valueExpressionInfo;
                  return c(r, o, e.expression);
                });
                _context.next = 6;
                return Promise.all(_e);

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function collectRequiredFields(_x, _x2) {
        return _collectRequiredFields.apply(this, arguments);
      }

      return collectRequiredFields;
    }()
  }, {
    key: "clone",
    value: function clone() {
      return new _m({
        data: o(this.data)
      });
    }
  }, {
    key: "hash",
    value: function hash() {
      return t(JSON.stringify(this.data)).toString();
    }
  }]);

  return m;
}(n);

r([e({
  json: {
    write: !1
  }
})], l.prototype, "color", void 0), r([e({
  json: {
    write: !0
  }
})], l.prototype, "data", void 0), r([a("data", ["symbol"])], l.prototype, "readData", null), r([p("data", {})], l.prototype, "writeData", null), r([s({
  CIMSymbolReference: "cim"
}, {
  readOnly: !0
})], l.prototype, "type", void 0), l = _m = r([i("esri.symbols.CIMSymbol")], l);
var d = l;
export { d as default };